import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getContactInformation,
  getIndividualForm,
  postIndividualForm,
  resetIndividualInformation,
} from "../redux/actions";

import CardHeader from "../components/CardHeader/CardHeader";
import CustomButton from "../components/CustomButton/CustomButton";
import CustomAlertLabel from "../components/CustomAlertLabel/CustomAlertLabel";
import Card from "../components/Card/Card";
import Select from "../components/Base/Select/Select";
import CustomTextBox from "../components/CustomTextBox/CustomTextBox";

import { defaultRegex, emailRegex, onlyDigits } from "../Regex";
import worldWideCountries from "../libs/worldWideCountries";

import styled from "styled-components";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import { SET_LOADING } from "../redux/action-types";
import Header from "../components/Header";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 3%;

  .formContainer__header {
    max-width: 100%;
  }

  .buttonContainer {
    margin: 2em;
    text-align: right;
    margin-top: 15px;
    @media (max-width: 480px) {
      margin: 0 7px 0 0;
    }
  }
  text-align: left;

  .inputBoxSection {
    margin: 1em;
  }

  input {
    margin: 0 -1em;
  }

  .hide {
    display: none;
  }
`;

const IndividualForm = () => {
  const worldWideCountriesArray = worldWideCountries();
  const us = worldWideCountriesArray?.find((item) => item.code === "US");
  worldWideCountriesArray?.splice(0, 0, us);
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    setGoalToLaunchPayLoad,
    individualInformation,
    loading,
    userAccountDetails,
  } = useSelector((state) => state.user);

  const [isLoaded, setIsLoaded] = useState(true);

  useEffect(() => {
    if (loading) {
      setIsLoaded(false);
    }
  }, [loading]);

  const actualGoalId = setGoalToLaunchPayLoad?.goalId;

  const states = individualInformation?.states;

  const [individualForm, setIndividualForm] = useState({
    goalId: actualGoalId,
    firstName: individualInformation?.firstName || "",
    lastName: individualInformation?.lastName || "",
    email: individualInformation?.email || "",
    numDependents: individualInformation?.contactInformation?.numDependents,
    countryOfBirth:
      individualInformation?.contactInformation?.countryOfBirth || "",
    residenceCountry:
      individualInformation?.contactInformation?.residenceCountry || "",
    residenceState:
      individualInformation?.contactInformation?.residenceState || "",
    legalResidenceCountry:
      individualInformation?.contactInformation?.legalResidenceCountry || "",
    legalResidenceState:
      individualInformation?.contactInformation?.legalResidenceState || "",
  });

  const handleSubmitButtonClick = () => {
    const validation = Object.values(individualForm);
    if (!validation.some((value) => value?.length === 0)) {
      dispatch({ type: SET_LOADING, payload: true });
      dispatch(postIndividualForm(individualForm));
      dispatch(resetIndividualInformation()).then(() =>
        dispatch(getContactInformation(actualGoalId))
      );
      history.push("/review-individual-form");
    } else setCustomAlertMessage("All fields are required");
  };

  const [customAlertMessage, setCustomAlertMessage] = useState("");

  useEffect(() => {
    if (actualGoalId) {
      dispatch(getIndividualForm(actualGoalId));
      dispatch({ type: SET_LOADING, payload: true });
    } else {
      dispatch({ type: SET_LOADING, payload: false });
      alert("missing goalId");
    }
  }, [actualGoalId, dispatch]);

  useEffect(() => {
    if (individualInformation && setGoalToLaunchPayLoad && userAccountDetails) {
      dispatch({ type: SET_LOADING, payload: false });
    }
  }, [
    dispatch,
    individualInformation,
    setGoalToLaunchPayLoad,
    userAccountDetails,
  ]);

  useEffect(() => {
    if (individualInformation) {
      setIndividualForm((prevState) => ({
        ...prevState,
        goalId: actualGoalId,
        firstName: userAccountDetails?.firstName || "",
        lastName: userAccountDetails?.lastName || "",
        email: individualInformation?.email || "",
        numDependents: individualInformation?.contactInformation?.numDependents,
        countryOfBirth:
          individualInformation?.contactInformation?.countryOfBirth || "",
        residenceCountry:
          individualInformation?.contactInformation?.residenceCountry || "",
        residenceState:
          individualInformation?.contactInformation?.residenceState || "",
        legalResidenceCountry:
          individualInformation?.contactInformation?.legalResidenceCountry ||
          "",
        legalResidenceState:
          individualInformation?.contactInformation?.legalResidenceState || "",
      }));
    }
  }, [actualGoalId, individualInformation, userAccountDetails]);

  const handleCustomTextBoxOnBlur = (property, value) => {
    setIndividualForm((prevState) => ({
      ...prevState,
      [property]: value,
    }));
  };
  return (
    <>
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      <Header />
      <BodyWrapper>
        <div className="formContainer">
          <Card>
            <div className="formContainer__header">
              <CardHeader text={"Let’s get started."} />
              <h2>Personal Information</h2>
              In order to open a trading account this information is needed to
              confirm your identity.
            </div>
            <div className="hide">
              <CustomTextBox
                value={"test"}
                onBlur={handleCustomTextBoxOnBlur}
              />
            </div>
            <div className="inputBoxSection">
              <CustomTextBox
                placeholder={"First Name"}
                value={individualForm?.firstName}
                name="firstName"
                errorMessage="Wrong First Name"
                regexCode={defaultRegex}
                onBlur={handleCustomTextBoxOnBlur}
              />
            </div>
            <div className="inputBoxSection">
              <CustomTextBox
                placeholder={"Last Name"}
                value={individualForm?.lastName}
                name="lastName"
                errorMessage="Wrong Last Name"
                regexCode={defaultRegex}
                onBlur={handleCustomTextBoxOnBlur}
              />
            </div>
            <div className="inputBoxSection">
              <CustomTextBox
                placeholder={"Email"}
                value={individualForm?.email}
                name="email"
                errorMessage="Wrong Email"
                regexCode={emailRegex}
                onBlur={handleCustomTextBoxOnBlur}
              />
            </div>
            <div className="inputBoxSection">
              <CustomTextBox
                blue
                placeholder={"Number of Dependents"}
                name="numDependents"
                regexCode={onlyDigits}
                errorMessage="Please enter a valid number"
                onBlur={handleCustomTextBoxOnBlur}
                value={individualForm?.numDependents}
              ></CustomTextBox>
            </div>
            <div style={{ marginTop: "-15px" }}>
              <Select
                isMarginLeftRequired={true}
                blue
                placeholder={
                  individualForm?.countryOfBirth || "Country of Birth"
                }
                value={"Country of Birth"}
                options={
                  worldWideCountriesArray?.map((state) => ({
                    label: `${state.name}`,
                    value: `${state.code}`,
                  })) || []
                }
                onChange={(value) =>
                  handleCustomTextBoxOnBlur("countryOfBirth", value)
                }
              ></Select>
              <Select
                isMarginLeftRequired={true}
                blue
                placeholder={
                  individualForm?.residenceCountry ||
                  "Country of Legal Residence"
                }
                value={"Country of Legal Residence"}
                options={[{ label: "USA", value: "USA" }]}
                onChange={(value) =>
                  handleCustomTextBoxOnBlur("residenceCountry", value)
                }
              ></Select>
              <Select
                isMarginLeftRequired={true}
                blue
                placeholder={
                  individualForm?.residenceState || "State of Legal Residence"
                }
                value={"State of Legal Residence"}
                options={
                  states?.map((state) => ({
                    label: `${state.name}`,
                    value: `${state.code}`,
                  })) || []
                }
                onChange={(value) =>
                  handleCustomTextBoxOnBlur("residenceState", value)
                }
              ></Select>
            </div>
            <h2>Tax Residency Details</h2>
            <div>
              <Select
                isMarginLeftRequired={true}
                blue
                placeholder={
                  individualForm?.legalResidenceCountry ||
                  "Country of Tax Residency"
                }
                value={
                  individualForm?.legalResidenceCountry ||
                  "Country of Tax Residency"
                }
                options={[{ label: "USA", value: "USA" }]}
                onChange={(value) =>
                  handleCustomTextBoxOnBlur("legalResidenceCountry", value)
                }
              ></Select>
              <Select
                isMarginLeftRequired={true}
                blue
                placeholder={
                  individualForm?.legalResidenceState ||
                  "State of Tax Residency"
                }
                value={"State of Tax Residency "}
                options={
                  states?.map((state) => ({
                    label: `${state.name}`,
                    value: `${state.code}`,
                  })) || []
                }
                onChange={(value) =>
                  handleCustomTextBoxOnBlur("legalResidenceState", value)
                }
              ></Select>
            </div>
          </Card>
          <div className="buttonContainer">
            <CustomButton
              text="BEGIN"
              nextLogo
              onClick={handleSubmitButtonClick}
            />
            <CustomAlertLabel message={customAlertMessage} />
            <CustomAlertLabel />
          </div>
        </div>
      </BodyWrapper>
    </>
  );
};

export default IndividualForm;
